/* React */
import React from "react";

/* Ionic */
import { IonSearchbar } from "@ionic/react";
import { search } from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./SearchbarContainer.module.scss";

const SearchbarContainer: React.FC = () => {
  return (
    <div className={styles.searchbar_container}>
      <IonSearchbar
        className={styles.searchbar}
        inputMode={"text"}
        debounce={500}
      />
      <PrimaryFabButton
        className={"primary"}
        ariaLabel={"Search button"}
        icon={search}
        scssProps={{
          height: "38px",
          width: "38px",
          icon: {
            height: "21px",
            width: "21px",
          },
        }}
      />
    </div>
  );
};

export default SearchbarContainer;
